// const columns = [
//   { name: "Status", uid: "status", sortable: false },
//   { name: "Industry", uid: "industry", sortable: false  },
//   { name: "Car", uid: "car", sortable: false  },
//   { name: "Part", uid: "part", sortable: false  },
//   { name: "Created", uid: "duration", sortable: false  },
//   { name: "delete", uid: "hidden", sortable: false },

// ];

const columns = [
  { uid: "status", name: "Status", sortable: false },
  { uid: "industry", name: "Industry", sortable: false },
  { uid: "car", name: "Car", sortable: false },
  { uid: "part", name: "Part", sortable: false },
  { uid: "duration", name: "Created", sortable: false },
  { uid: "delete", name: "Hide", sortable: false }, // <-- ADDED
];
const statusOptions = [
  { name: "all", uid: "all" },
  { name: "Initiated", uid: "initiated" },
  { name: "Processing", uid: "processing" },
  { name: "Shipped", uid: "shipped" },
  { name: "In Transit", uid: "in Transit" },
  { name: "Completed", uid: "completed" },
  { name: "Delivered", uid: "delivered" },
  { name: "Dispute", uid: "dispute" },
  { name: "Cancelled", uid: "cancelled" },
];

export { columns, statusOptions };
